import {
  Dokument as BffDokument,
  DokumentenErstellungRequestModel,
  JagdbestaetigungDruckdaten,
  SparteDruckdaten,
} from '@ps20/bff-models';
import cloneDeep from 'lodash/cloneDeep';
import { getTarifbereich } from '@ps20-frontend/frontend-models';
import { convertDate } from '@ps20-frontend/utils';
import { IAppState } from '../../localStore';
import { Jagdschein } from '../../reducer/jhpAngaben.reducer';
import {
  addCheckoutDataToSparteDruckdaten,
  mapAntraege,
  mapVermittler,
  mapVersicherungsnehmer,
} from './common-druckdaten.mapper';

export const mapJagdbestaetigung = (
  state: IAppState,
  sparteDruckdaten: SparteDruckdaten,
): DokumentenErstellungRequestModel<JagdbestaetigungDruckdaten> => {
  const commonJagdDruckdaten = {
    antraege: mapAntraege([sparteDruckdaten]),
    sammelantragsnummer: state.sammelantragsnummer,
    tarifbereich: getTarifbereich(state.versicherungsnehmer),
    vermittler: mapVermittler(state),
    versicherungsnehmer: mapVersicherungsnehmer(state),
    sparteDruckdaten: sparteDruckdaten,
    dokumentDruckdaten: {
      dokument: BffDokument.JAGDBESTAETIGUNG,
      jagdschein: mapJagdschein(state),
      jagdscheinAblaufdatum: convertDate(state.jhpAngaben.jagdscheinAblaufdatum),
    },
  };

  const clonedJagdDruckdaten: DokumentenErstellungRequestModel<JagdbestaetigungDruckdaten> =
    cloneDeep(commonJagdDruckdaten);
  clonedJagdDruckdaten.sparteDruckdaten = addCheckoutDataToSparteDruckdaten(
    state,
    sparteDruckdaten,
  );
  return clonedJagdDruckdaten;
};

export function mapJagdschein(state: IAppState): number {
  if (state.jhpAngaben != null && state.jhpAngaben.jagdschein != null) {
    if (state.jhpAngaben.jagdschein === Jagdschein.JAHRES_JAGDSCHEIN) {
      return 1;
    }
    return 3;
  }
  return undefined;
}
